export const RESOURCE_TYPE_PROJECT_CONTEXT = 'PROJECT_CONTEXT';
